import JSONSchema7Properties from '../jSONSchema7Properties';

export default (properties: JSONSchema7Properties) => {
  const roleKeys = [];
  for (const property in properties) {
    if (property.includes('role-')) {
      roleKeys.push(property);
    }
  }
  return roleKeys;
};
